import { combineEpics, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { asyncFinish } from '../../../common/+store/async';
import { commonApiCallFragment } from '../../../common/+store/utils/utils.api';
import { GET_CAMPUS_GROUPS, SAVE_CAMPUS_GROUP, DELETE_CAMPUS_GROUP } from './CampusGroups.actions';
import { getCampusGroups, saveCampusGroup, deleteCampusGroup } from './CampusGroups.api';

const getCampusGroupsEpic = (action$) =>
  action$.pipe(
    ofType(GET_CAMPUS_GROUPS),
    switchMap((action) =>
      from(getCampusGroups()).pipe(commonApiCallFragment(action$, action, 'Getting Campus Groups'))
    ),
    switchMap((results) => {
      if (results.success) {
        return of(asyncFinish(GET_CAMPUS_GROUPS, results.response.data));
      }
      if (results.actions) return of(...results.actions);
      return of(results.action);
    })
  );

const saveCampusGroupEpic = (action$) =>
  action$.pipe(
    ofType(SAVE_CAMPUS_GROUP),
    switchMap((action) =>
      from(saveCampusGroup(action.data)).pipe(commonApiCallFragment(action$, action, 'Save Campus Group'))
    ),
    switchMap((results) => {
      if (results.success) {
        return of(asyncFinish(SAVE_CAMPUS_GROUP, results.response.data));
      }
      if (results.actions) return of(...results.actions);
      return of(results.action);
    })
  );

const deleteCampusGroupEpic = (action$) =>
  action$.pipe(
    ofType(DELETE_CAMPUS_GROUP),
    switchMap((action) =>
      from(deleteCampusGroup(action.data)).pipe(commonApiCallFragment(action$, action, 'Delete Campus Group'))
    ),
    switchMap((results) => {
      if (results.success) {
        return of(asyncFinish(DELETE_CAMPUS_GROUP, results.response.data));
      }
      if (results.actions) return of(...results.actions);
      return of(results.action);
    })
  );

const epics = combineEpics(getCampusGroupsEpic, saveCampusGroupEpic, deleteCampusGroupEpic);

export default epics;
